import React, { useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import PlotlyPlot from "react-plotly.js";
import TextTruncate from "components/TextTruncate";
import HtmlText from "components/HtmlText";
import { plotConfig, plotLayout, prepareAdditionalTraces, prepareMainTrace } from "./utils";
import { useClonePlotClosestLegend, useRoundTickValueObserver } from "shared/plotly/hooks";
import { cellModelParameterUnitsType, findDictionaryItemByValue } from "shared/rsDictionary";
import { variableDependencyGraphDataSelector } from "store/cell-model/cell-model.selectors";
import { NoUnitsType } from "store/recipe/recipe.types";
import * as styles from "./styles.module.scss";
const DependencyGraph = ({ dynamicName, variableName, className, units }) => {
    const plotRef = useRef(null);
    const [plotHoverEvent, setPlotHoverEvent] = useState(null);
    const graphData = useSelector(variableDependencyGraphDataSelector);
    const preparedData = useMemo(() => {
        if (!graphData) {
            return [];
        }
        else {
            return [
                ...prepareAdditionalTraces(graphData.additional),
                prepareMainTrace(graphData.mainChart, variableName),
            ];
        }
    }, [graphData, variableName]);
    useClonePlotClosestLegend(plotRef?.current?.el, plotHoverEvent);
    useRoundTickValueObserver(plotRef);
    const unitsLabel = useMemo(() => units && units !== NoUnitsType.NoUnits
        ? findDictionaryItemByValue(cellModelParameterUnitsType, units)?.label
        : undefined, [units]);
    return (React.createElement("div", { className: classNames(styles.plotWrapper, className) },
        React.createElement("div", { className: styles.dynamicName },
            React.createElement(TextTruncate, { text: `rate of ${dynamicName}` })),
        React.createElement(PlotlyPlot, { ref: plotRef, config: plotConfig, data: preparedData, layout: plotLayout, className: styles.plot, onHover: setPlotHoverEvent, onUnhover: setPlotHoverEvent }),
        React.createElement("div", { className: styles.variableName },
            React.createElement(HtmlText, { text: `${variableName}${unitsLabel ? `, ${unitsLabel}` : ""}` }))));
};
export default DependencyGraph;
